var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { staticClass: "v-chart" },
    [
      _c(
        "svg",
        {
          attrs: {
            width: _vm.renderWidth,
            height: _vm.renderHeight,
            xmlns: "http://www.w3.org/2000/svg",
          },
        },
        [
          _vm.title
            ? _c(
                "text",
                {
                  staticClass: "v-chart__title",
                  attrs: { name: "title", x: "0", y: _vm.titleY },
                },
                [_vm._v(" " + _vm._s(_vm.title) + " ")]
              )
            : _vm._e(),
          _c("g", { ref: "back", attrs: { name: "axis" } }),
          _vm._t("default"),
          _vm.comment
            ? _c(
                "text",
                {
                  staticClass: "v-chart__comment",
                  attrs: {
                    name: "comment",
                    x: "100%",
                    y: _vm.commentY,
                    "text-anchor": "end",
                  },
                },
                [_vm._v(" " + _vm._s(_vm.comment) + " ")]
              )
            : _vm._e(),
        ],
        2
      ),
      _c("v-chart-legend", {
        style: { top: `${_vm.legendY}px`, right: `3px` },
        attrs: {
          legend: _vm.legend,
          legends: _vm.legends,
          legendColor: _vm.legendColor,
          hideLegends: _vm.hideLegends,
        },
        on: { change: _vm.change },
      }),
      _vm._t("tip"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }